module.exports = __webpack_public_path__ + "image/share_facebook.png";